import type { DocCategory } from '../registry';
import StandaloneApp, { toc as standaloneAppToc } from '../pages/platforms/standalone-app';
import PremierePanel, { toc as premierePanelToc } from '../pages/platforms/premiere-panel';

export const platforms: DocCategory = {
  id: 'platforms',
  label: 'Platforms',
  pages: [
    {
      slug: 'platforms/standalone-app',
      title: 'The desktop app',
      eyebrow: 'Platforms',
      description: 'ClipRadar as a standalone Windows app — the primary way to use it, independent of Premiere.',
      toc: standaloneAppToc,
      Body: StandaloneApp,
      related: [
        { label: 'The Adobe Premiere Pro panel', to: '/docs/platforms/premiere-panel' },
        { label: 'From search results to a rough cut', to: '/docs/guides/build-a-rough-cut' },
        { label: 'Licensing & activation', to: '/docs/concepts/licensing' },
      ],
    },
    {
      slug: 'platforms/premiere-panel',
      title: 'The Adobe Premiere Pro panel',
      eyebrow: 'Platforms',
      description: 'Install and use the Premiere panel — the fully illustrated Windows install guide.',
      toc: premierePanelToc,
      Body: PremierePanel,
      related: [
        { label: 'The desktop app', to: '/docs/platforms/standalone-app' },
        { label: 'From search results to a rough cut', to: '/docs/guides/build-a-rough-cut' },
        { label: "The Premiere panel won't open or is blank", to: '/docs/troubleshooting/panel-wont-open' },
      ],
    },
  ],
};
